// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c246440","239":"2b17afd9","453":"68693753","732":"c35785e5"}[chunkId] + ".chunk.js";
};